module.exports = __webpack_public_path__ + "img/pic_company_logo_S.a87f6b59.png";